import { CitationColumn } from 'app/models/all-data.models';
import { Column } from 'app/models/columns-dialog.models';

export const sliceAndAddStar = (value: string, count = 5): string => {
  return value.slice(0, count) + '***';
};

export const getDefaultAllDataColumns = (isPersonalInfoEnabled: boolean): CitationColumn[] => {
  return [
    CitationColumn.Id,
    CitationColumn.Month,
    CitationColumn.Date,
    CitationColumn.Time,
    CitationColumn.DayNight,
    CitationColumn.DayOfWeek,
    ...(isPersonalInfoEnabled
      ? [
          CitationColumn.DriverLastName,
          CitationColumn.DriverFirstName,
          CitationColumn.DriverMiddleName,
          CitationColumn.DateOfBirth,
        ]
      : []),
    CitationColumn.Race,
  ];
};

export const getColumns = (isPersonalInfoEnabled: boolean): Column[] => [
  {
    columnDef: CitationColumn.Id,
    title: 'Citation №',
    checkboxDisabled: true,
  },
  { columnDef: CitationColumn.Month, title: 'Month' },
  { columnDef: CitationColumn.IssueType, title: 'Citation Type' },
  { columnDef: CitationColumn.CitationType, title: 'Citation Name' },
  {
    columnDef: CitationColumn.OffenceCode,
    title: 'Offense Code',
  },
  { columnDef: CitationColumn.Date, title: 'Citation Date' },
  { columnDef: CitationColumn.Time, title: 'Violation Time' },
  { columnDef: CitationColumn.DayNight, title: 'Day / Night' },
  { columnDef: CitationColumn.DayOfWeek, title: 'Day of Week' },
  { columnDef: CitationColumn.Department, title: 'Department' },
  ...(isPersonalInfoEnabled
    ? [
        {
          columnDef: CitationColumn.DriverLastName,
          title: 'Citation Last Name',
        },
        {
          columnDef: CitationColumn.DriverFirstName,
          title: 'Citation First Name',
        },
        {
          columnDef: CitationColumn.DriverMiddleName,
          title: 'Citation Middle Name',
        },
        { columnDef: CitationColumn.DateOfBirth, title: 'Citation DOB' },
      ]
    : []),
  {
    columnDef: CitationColumn.PhoneNumberCaptured,
    title: 'Phone Number Captured',
  },
  { columnDef: CitationColumn.Race, title: 'Race' },
  { columnDef: CitationColumn.Sex, title: 'Sex' },
  { columnDef: CitationColumn.AgeGroup, title: 'Age Group' },
  { columnDef: CitationColumn.ZipCode, title: 'Zip code' },
  { columnDef: CitationColumn.City, title: 'City' },
  { columnDef: CitationColumn.VehicleYear, title: 'Vehicle Year' },
  { columnDef: CitationColumn.VehicleMake, title: 'Vehicle Make' },
  { columnDef: CitationColumn.VehicleModel, title: 'Vehicle Model' },
  { columnDef: CitationColumn.VehicleColor, title: 'Vehicle Color' },
  { columnDef: CitationColumn.VehicleType, title: 'Vehicle Type' },
  ...(isPersonalInfoEnabled
    ? [
        {
          columnDef: CitationColumn.Officer,
          title: 'Officer',
        },
        {
          columnDef: CitationColumn.OfficerId,
          title: 'Officer Id',
        },
      ]
    : []),
];

export const isValueNotEmpty = (value: unknown) => {
  if (!value) return value;

  if (typeof value === 'object') {
    if (Array.isArray(value)) return value.length;

    return Object.values(value).some((x) => x);
  }

  return value;
};
